import * as React from 'react';
import BriefEntry from '@99designs/apps/spa/pages/create/briefs/BriefEntry';
import CreateSquareOnlineStore from '@99designs/apps/spa/pages/create/briefs/squareOnlineStore/CreateSquareOnlineStore';
import Layout from '@99designs/apps/spa/pages/create/components/Layout';
// Polyfill for IE11, can be dropped once we remove IE11 support
import 'url-search-params-polyfill';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Brief from '@99designs/apps/spa/pages/create/briefs/Brief';
import EssentialsProductSelection from '@99designs/apps/spa/pages/create/briefs/EssentialsProductSelection/EssentialsProductSelection';
import FacebookCreate from '@99designs/apps/spa/pages/create/briefs/FacebookAd/FacebookCreate';
import FullServiceBrandingProductSelection from '@99designs/apps/spa/pages/create/briefs/FullServiceBranding/FullServiceBrandingProductSelection';
import { LandingPage as SquareOnlineSelfServeLandingPage } from '@99designs/apps/spa/pages/create/briefs/SquareOnlineSelfServe/LandingPage';
import ThemeifyYourLogoProductSelection from '@99designs/apps/spa/pages/create/briefs/ThemeifyYourLogo/ThemeifyYourLogoProductSelection';
import WixCreate from '@99designs/apps/spa/pages/create/briefs/Wix/WixCreate';
import { CreateBriefWithSlug } from '@99designs/apps/spa/pages/create/mutations/CreateBriefWithSlug';
import { useViewer } from '@99designs/viewer';
import BriefOrderItem from './briefs/BriefOrderItem';

const redirects: Record<string, string> = {
    'facebook-ad-custom/create': '/briefs/create/facebook-ad-custom',
    'facebook-ad/create': '/briefs/create/facebook-ad',
    'logo-web-bundle/create': '/briefs/create/logo-web-bundle',
    'nationbuilder/create': '/briefs/create/nationbuilder',
    'packlane/create': '/briefs/create/packlane',
    'prezi/create': '/briefs/create/prezi',
    'square-online-ecommerce/create': '/briefs/create/square-online-store-ecommerce',
    'square-online-full-site/create': '/briefs/create/square-online-complete',
    'square-online-ordering-page/create': '/briefs/create/square-online-store-ecommerce',
    'square-online-self-serve/create': '/briefs/create/square-online-self-serve',
    'square-online-store-ecommerce/create': '/briefs/create/square-online-store-ecommerce',
    'square-online-store-restaurant/create': '/briefs/create/square-online-restaurant',
    'squarespace-commerce/create': '/briefs/create/squarespace-web-commerce',
    'squarespace-essential/create': '/briefs/create/squarespace-web-essential',
    'squarespace/create': '/briefs/create/squarespace',
    'web-builder/create': '/briefs/create/web-builder',
    'project/create': '/briefs/create',
    'projects/create': '/briefs/create',
    'square-online-store/create': '/briefs/square-online/create',
    'create/square-online-ecommerce': '/briefs/create/square-online-store-ecommerce',
};

export const BriefRoutes = () => {
    const { search } = useLocation();
    const viewer = useViewer();

    return (
        <Layout>
            <Routes>
                <Route
                    path="create"
                    element={
                        viewer ? (
                            <BriefEntry />
                        ) : (
                            <Navigate replace to={{ pathname: '/briefs/create/project', search }} />
                        )
                    }
                />
                {Object.keys(redirects).map((from) => (
                    <Route
                        key={from}
                        path={from}
                        element={<Navigate replace to={{ pathname: redirects[from], search }} />}
                    />
                ))}
                <Route path="create/:slug" element={<CreateBriefWithSlug />} />

                {/* Square package selection */}
                <Route path="square-online/create" element={<CreateSquareOnlineStore />} />
                <Route
                    path="square-online-self-serve"
                    element={<SquareOnlineSelfServeLandingPage />}
                />

                {/* Facebook package selection */}
                <Route path="facebook/create" element={<FacebookCreate />} />

                {/* Wix package selection */}
                <Route path="wix/create" element={<WixCreate />} />

                {/* Full service branding package selection */}
                <Route
                    path="full-service-branding/create"
                    element={<FullServiceBrandingProductSelection />}
                />

                {/* Theme-ify your logo package selection */}
                <Route
                    path="theme-ify-your-logo/create"
                    element={<ThemeifyYourLogoProductSelection />}
                />

                {/* Essential Product selection pages */}
                <Route
                    path="business-card/create"
                    element={
                        <EssentialsProductSelection
                            category="business-card-design"
                            fromPrice={16900}
                        />
                    }
                />
                <Route
                    path="brochure/create"
                    element={
                        <EssentialsProductSelection category="brochure-design" fromPrice={32900} />
                    }
                />
                <Route
                    path="postcard-flyer/create"
                    element={
                        <EssentialsProductSelection
                            category="postcard-flyer-design"
                            fromPrice={16900}
                        />
                    }
                />
                <Route
                    path="stand-up-pouch/create"
                    element={
                        <EssentialsProductSelection
                            category="product-packaging-design"
                            fromPrice={34900}
                        />
                    }
                />
                <Route path=":briefId" element={<Navigate to="./1" replace />} />
                <Route path=":briefId/:step" element={<Brief />} />
                <Route path="order-item/:orderItemId" element={<BriefOrderItem />} />
            </Routes>
        </Layout>
    );
};

export default BriefRoutes;
